import React from 'react';
import { LayoutDashboard, User, CalendarRange } from 'lucide-react';
import type { GetCaseOverviewWidgetData } from '../../../types/agentWidgets';

interface Props {
  data: GetCaseOverviewWidgetData;
}

export const GetCaseOverviewWidget: React.FC<Props> = ({ data }) => {
  return (
    <div className="mt-1.5 space-y-1.5 text-[11px] bg-gray-50/70 dark:bg-gray-800/30 rounded px-2 py-1.5">
      <div className="flex items-center gap-2">
        <LayoutDashboard className="h-3 w-3 text-gray-500 dark:text-gray-400 flex-shrink-0" />
        <span className="font-medium text-gray-700 dark:text-gray-300 truncate">
          {data.caseName}
        </span>
        {data.status && (
          <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-cyan-100 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-400 whitespace-nowrap">
            {data.status.toLowerCase()}
          </span>
        )}
        {data.documentCount != null && (
          <span className="text-[10px] text-gray-400 dark:text-gray-500 whitespace-nowrap">
            {data.documentCount} docs
          </span>
        )}
      </div>
      {data.patients.length > 0 && (
        <div className="flex items-center gap-1.5 ml-5">
          <User className="h-2.5 w-2.5 text-gray-400 flex-shrink-0" />
          <span className="text-gray-500 dark:text-gray-400">
            {data.patients.map((p) => p.name).join(', ')}
          </span>
        </div>
      )}
      {data.incidentPeriod && (
        <div className="flex items-center gap-1.5 ml-5">
          <CalendarRange className="h-2.5 w-2.5 text-gray-400 flex-shrink-0" />
          <span className="text-gray-500 dark:text-gray-400">
            {data.incidentPeriod.from}
            {data.incidentPeriod.to && ` — ${data.incidentPeriod.to}`}
          </span>
        </div>
      )}
    </div>
  );
};
